import { createSlice, PayloadAction } from "@reduxjs/toolkit";
import { ClicksForAnalysis } from "app/ApiClient";
import { getProjectHeatmapSettings } from "slices/projectHeatmapSettings/projectHeatmapSettingsSlice";

export interface SelectedClicksState {
  selectedClicks: ClicksForAnalysis;
}

const initialState = {
  selectedClicks: ClicksForAnalysis.All,
} as SelectedClicksState;

const selectedClicksSlice = createSlice({
  name: "selectedClicks",
  initialState: initialState,
  reducers: {
    resetSelectedClicks: () => initialState,
    setSelectedClicks: (state, action: PayloadAction<ClicksForAnalysis>) => {
      state.selectedClicks = action.payload;
    },
  },
  extraReducers: (builder) => {
    builder.addCase(getProjectHeatmapSettings.fulfilled, (state, action) => {
      const selectedClicks = action.payload.projectSettings.selectedClicks;
      return selectedClicks ?? initialState;
    });
  },
});

export const { setSelectedClicks, resetSelectedClicks } = selectedClicksSlice.actions;

export default selectedClicksSlice.reducer;
